export enum ReturnStatus {
    // OPEN statuses
    REQUESTED = "REQUESTED", // NEEDS_REVIEW - Return has been requested by customer but not reviewed by store yet
    APPROVED = "APPROVED", // Store has reviewed and approved the return, generates label, waiting for customer to send back
    PROCESSING = "PROCESSING", // NEEDS_REVIEW - Store received return and has made an update to it

    // Negative closed states
    CUSTOMER_CANCELLED = "CUSTOMER_CANCELLED", // Customer cancelled the return but put on hold in case it needs to reopen
    CANCELLED = "CANCELLED", // More aggressive way to cancel the return and it can't be reopened by customer
    REJECTED = "REJECTED", // Reviewed by store and they rejected the return (should have a rejected reason attached)

    // 'positive' CLOSED states
    RESOLVED = "RESOLVED", // Customer reached out and said no worries or another resolution option occurred
    REFUNDED = "REFUNDED", // Customer has been refunded
    EXCHANGED = "EXCHANGED", // Customer has been refunded and exchanged items sent

    EXPIRED = "EXPIRED" // Past window for USPS, UPS, or FEDEX
}